import { memo } from 'react';
import { motion } from 'motion/react';
import { useAgentContext } from '@Providers';

import { GeneratedFile } from '@Models';
import { AGENT_DURATIONS, AGENT_EASING } from '../../../Helpers/Agents/animations';
import FileDownloadButton from '../../FileDownloadButton/FileDownloadButton';

interface MessageUserProps {
  content: string;
  attachments?: GeneratedFile[];
  /** The files are still uploading: the cards show a spinner and cannot download yet. */
  attachmentsUploading?: boolean;
  conversationId: string;
  interactionTimestamp: string;
}

const MessageUser = ({
  content,
  attachments,
  attachmentsUploading = false,
  conversationId,
  interactionTimestamp,
}: MessageUserProps) => {
  const { mode } = useAgentContext();
  const isFullscreen = mode === 'fullscreen';

  const maxWidth = isFullscreen ? 'max-w-[82%]' : 'max-w-[80%]';
  const sizing = isFullscreen ? 'rounded-2xl px-4 py-2.5 text-[15px]' : 'rounded-xl px-3 py-1.5 text-[13px]';

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: AGENT_DURATIONS.fast, ease: AGENT_EASING.outExpo }}
      className="flex flex-col items-end gap-2">
      {attachments && attachments.length > 0 && (
        <div className={`flex flex-wrap justify-end gap-2 ${maxWidth}`}>
          {attachments.map((file, idx) => (
            <FileDownloadButton
              key={file.file_name}
              file={file}
              source="attachment"
              uploading={attachmentsUploading}
              conversationId={conversationId}
              timestamp={interactionTimestamp}
              index={idx}
            />
          ))}
        </div>
      )}
      {content && (
        <div
          className={`font-medium leading-relaxed text-gray-900 ${maxWidth} ${sizing}`}
          style={{
            backgroundColor: 'rgba(124, 108, 246, 0.06)',
            border: '1px solid rgba(124, 108, 246, 0.12)',
          }}>
          {content}
        </div>
      )}
    </motion.div>
  );
};

export default memo(MessageUser);
